import React from "react";
import Sidebar from "./Sidebar";
import { Outlet } from "react-router-dom";

const AppLayout = () => {
  return (
    <div className="min-h-screen grain-bg flex" style={{ background: "var(--bg)" }}>
      <Sidebar />
      <main className="flex-1 min-w-0 px-4 sm:px-8 lg:px-12 py-6 lg:py-10">
        <Outlet />
      </main>
    </div>
  );
};

export default AppLayout;
